
// Libraries
import { defineComponent } from 'vue';

// Components
import LoadingIcon from 'components/LoadingIcon.vue';
import LoginAlert from 'client/components/LoginAlert.vue';

export default defineComponent({
  name: 'DuoView',

  components: {
    LoadingIcon,
    LoginAlert,
  },

  props: {
    errorMessage: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    showFrame: {
      type: Boolean,
      required: true,
    },
  },
});
